export default __webpack_public_path__ + "static/media/LawOverviewSearchBg.14bdb7b2.jpg";